import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { FieldArray, reduxForm } from 'redux-form';
import * as valid from 'utils/validate';
import { DAY_TIME_HM } from 'app/constants';
import { lockPermissionsActions, successState } from 'app/actions';
import { api, apiUtils } from 'app/services';
import {
KBPopover,
KBUserInput,
KBFormError,
KBButton,
KBDateInput,
KBSelect } from
'components';
import dayjs from 'utils/dayjs';
import { toKBArrayField } from 'components/formAdapters/reduxFormAdapters';
import { showApiError } from 'utils/feedback';

class LockPermissionTimeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || ''
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const nextValue = this.props.value || '';
    if (prevProps.value !== this.props.value && nextValue !== this.state.value) {
      this.setState({ value: nextValue });
    }
  }

  handleChange(value) {
    this.setState({ value: value });
    this.props.onChange && this.props.onChange(value);
  }

  render() {
    const { onChange, value, field, ...rest } = this.props;
    return (
      <KBSelect
        {...rest}
        field={{ value: this.state.value, onChange: () => {} }}
        onChange={this.handleChange} />
    );
  }
}

var LockPermissionsUpdateForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.updateLockForm = this.updateLockForm.bind(this);this.changeYMD = this.changeYMD.bind(this);this.changeHM = this.changeHM.bind(this);this.renderLockPermissions = this.renderLockPermissions.bind(this);}getInitialState()
  {
    return {};
  }updateLockForm(
  model) {
    const {
      loc_id,
      successActions,
      updateLocksPermissionsAction,
      isGroup,
      allPermissions } =
    this.props;

    if (isGroup) {
      let newValue = model.lock_permissions[0];
      model.lock_permissions = allPermissions.map(p => {
        let newP = {};
        newP.id = p.id;
        newP.start_at = newValue.start_at;
        newP.end_at = newValue.end_at;
        return newP;
      });
    }

    return api.updateLockPermissions(loc_id, model).then(json => {
      updateLocksPermissionsAction.success(json);
      successActions({
        message: isGroup ? '门禁组权限修改成功' : '门禁权限修改成功' });

      KBPopover.close();
      return true;
    }).catch(error => {
      showApiError(error);
    });
  }changeYMD(

  fields, index, dateField, timeField, value) {
    const date = dayjs(value);
    this.props.change(`lock_permissions[${index}].${dateField}`, value);
    this.props.change(`lock_permissions[${index}].${timeField}`, currentValue => {
      const current = dayjs(currentValue);
      return (current.isValid() ? current : dayjs()).
      year(date.year()).
      month(date.month()).
      date(date.date()).
      second(0).
      millisecond(0).
      toDate();
    });

  }changeHM(

  fields, index, hmField, timeField, value) {
    const selected = value == null ? '' : String(value);
    const parts = selected.split(',');
    const hour = parseInt(parts[0], 10);
    if (isNaN(hour)) {
      return;
    }
    const minute = parts[1] === '1' ? 0 : 30;
    this.props.change(`lock_permissions[${index}].${hmField}`, selected);
    this.props.change(`lock_permissions[${index}].${timeField}`, currentValue => {
      const current = dayjs(currentValue);
      return (current.isValid() ? current : dayjs()).
      hour(hour).
      minute(minute).
      second(0).
      millisecond(0).
      toDate();
    });

  }renderLockPermissions({ fields, meta }) {
    const { isGroup, submitting, DEAL_DAY_TIME_HM } = this.props;
    const lock_permissions = toKBArrayField(fields);
    const halfClass = {
      className: 'kb-form-group kb-div-c48'
    };

    return lock_permissions.length > 0 &&
    lock_permissions.map((permissions, index) => {
      return (
        <div className="kb-form-container-m" key={index}>
          {isGroup ?
          <div className="kb-tip-warning">
            <div className="icon">
              <i className="iconfont icon-hint" />
            </div>
            <div className="msg">
              此修改将会应用到当前门禁组下的所有门禁权限
            </div>
          </div> :
          null}
          <div className="kb-row kb-form-66">
            <KBDateInput
              type="date"
              title="开始日期"
              isRequired={true}
              className="kb-form-group kb-div-48"
              field={{ ...permissions.startYMD, onChange: () => {} }}
              onChange={data => this.changeYMD(fields, index, 'startYMD', 'start_at', data)} />

            <LockPermissionTimeSelect
              title="开始时间"
              titleClass="label-rt"
              arrayData={DEAL_DAY_TIME_HM}
              value={permissions.startHM && permissions.startHM.value}
              onChange={data => this.changeHM(fields, index, 'startHM', 'start_at', data)}
              {...halfClass} />

          </div>
          <div className="kb-row kb-form-66">
            <KBDateInput
              type="date"
              title="结束日期"
              isRequired={true}
              className="kb-form-group kb-div-48"
              field={{ ...permissions.endYMD, onChange: () => {} }}
              onChange={data => this.changeYMD(fields, index, 'endYMD', 'end_at', data)} />

            <LockPermissionTimeSelect
              title="结束时间"
              titleClass="label-rt"
              arrayData={DEAL_DAY_TIME_HM}
              value={permissions.endHM && permissions.endHM.value}
              onChange={data => this.changeHM(fields, index, 'endHM', 'end_at', data)}
              {...halfClass} />

          </div>
          {meta.submitFailed && meta.error ?
          <p className="lr-error">{meta.error}</p> :
          null}
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
              className="certain-btn"
              type="submit"
              submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>);
    });
  }render()

  {
    const { handleSubmit, isGroup } = this.props;

    return (
      <form onSubmit={handleSubmit(this.updateLockForm)}>
        <KBFormError error={this.props.error} />
        <header className="kb-form-header">
          <h2 className="header-title">
            {isGroup ? '修改门禁组权限' : '修改门禁权限'}
          </h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <FieldArray
          name="lock_permissions"
          rerenderOnEveryChange
          component={this.renderLockPermissions} />
      </form>);

  }};


function mapStateToProps(state, props) {
  let DEAL_DAY_TIME_HM = DAY_TIME_HM(0, 24);
  return {
    DEAL_DAY_TIME_HM };

}

function mapDispatchToProps(dispatch) {
  return {
    updateLocksPermissionsAction: bindActionCreators(
    lockPermissionsActions.update,
    dispatch),

    successActions: bindActionCreators(successState, dispatch) };

}

const validatePermissions = Permissions => {
  const errors = {};

  if (
  Permissions.start_at &&
  Permissions.end_at &&
  dayjs(Permissions.end_at).
  startOf('minute').
  diff(dayjs(Permissions.start_at).startOf('minute')) <= 0)
  {
    errors.endHM = '结束日期必须大于开始日期';
  }

  return errors;
};

const validate = values => {
  const errors = {};

  errors.lock_permissions = (values.lock_permissions || []).map(validatePermissions);
  const lockPermissionError = errors.lock_permissions.find(permission => {
    return permission.endHM;
  });
  if (lockPermissionError) {
    errors.lock_permissions._error = lockPermissionError.endHM;
  }

  return errors;
};

const formConfig = {
  form: 'MeetingForm',
  validate: validate,
  touchOnBlur: false };


LockPermissionsUpdateForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(LockPermissionsUpdateForm));

export default LockPermissionsUpdateForm;
